import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Alert } from '@mui/material';
import DialogComponent from '../../../common/components/DialogComponent.jsx';
import ProgressOverlay from '../../../common/components/ProgressOverlay.jsx';

const CustomerComplianceModal = ({ open, onClose, loading, data, error }) => {
  return (
    <DialogComponent open={open} onClose={onClose} title="Compliance Details" setWidth="md">
      {loading ? (
        <ProgressOverlay />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : !data || data.length === 0 ? (
        <Alert severity="info">No compliance records found for this conversation.</Alert>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><b>Group</b></TableCell>
              <TableCell><b>Rule ID</b></TableCell>
              <TableCell><b>Description</b></TableCell>
              <TableCell><b>Compliant</b></TableCell>
              <TableCell><b>Comments</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.Group}</TableCell>
                <TableCell>{row.ruleid}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{String(row.compliant)}</TableCell>
                <TableCell>{row.comments}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </DialogComponent>
  );
};

export default CustomerComplianceModal;
